import React, { useEffect, useState } from "react";
import { api } from "../../../api";
import Button from "../../../components/buttons/Button";
import {
  FaCcAmex,
  FaCreditCard,
  FaCcDinersClub,
  FaCcDiscover,
  FaCcJcb,
  FaCcMastercard,
  FaCcVisa,
  FaPlus,
} from "react-icons/fa";
import { brandConfig } from "../../../helpers/brandConfig";
import { loadStripe } from "@stripe/stripe-js";
import ReplaceWhileLoading from "../../../components/loadingIndicator/ReplaceWhileLoading";
import { UserInfo } from "../userSettingsTypes";
import Snackbar from "../../../components/snackbar/snackbar";

const Payment = ({ userInfo }: { userInfo: UserInfo }) => {
  const [stripeCustomerPortalUrl, setStripeCustomerPortalUrl] = useState<
    string | null
  >(null);

  useEffect(() => {
    const fetchStripeCustomerPortalUrl = async () => {
      const url = await api.getStripeCustomerPortalUrl();
      if (typeof url === "string") {
        setStripeCustomerPortalUrl(url);
      }
    };
    fetchStripeCustomerPortalUrl();
  }, []);

  return (
    <div>
      <Button
        startDisabled={!stripeCustomerPortalUrl}
        style="text"
        link={stripeCustomerPortalUrl || undefined}
        newTab
      >
        Billing Info / Update
      </Button>
    </div>
  );
};

export default Payment;
